const geracao_das_vagas = [
  {
    path: "/geracao_de_vagas",
    redirect: "/geracao_de_vagas",
    meta: {
      breadCrumb: "Gerenciamento de Matrícula - Geração de Vagas",
    },
    children: [
      {
        path: "/geracao_de_vagas",
        name: "geracao_de_vagas",
        meta: {
          allowedPermissions: ["geracao_de_vagas"],
        },
        component: () =>
          import("@/views/GeracaoDasVagas/GeracaoDasVagasHome.vue"),
      },
    ],
  },
];

export { geracao_das_vagas };
